import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule, ModuleWithProviders, SkipSelf, Optional, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Our own stuff
import { AuthInterceptor } from '@app/common/auth-interceptor';
import { FilterPipe } from '@app/pipes/filter.pipe';

// Modules
import { MaterialModule } from '@app/modules/material/material.module';

import { SharedModule } from '@app/modules/shared/shared.module';

/* tslint:disable */
// Lazy loaded modules - only imported for compiler, not used in any way here (they are bundled separately due to being lazy)
import { ConnectProjectModule } from '@app/modules/connect-project/connect-project.module';
/* tslint:enable */

// Views
import { MainComponent } from '@app/views/main/main.component';
import { AllProjectsComponent } from '@app/views/all-projects/all-projects.component';
import { MyProjectsComponent } from '@app/views/my-projects/my-projects.component';

// Components
import { AppComponent } from '@app/app.component';
import { TopnavComponent } from '@app/components/header/topnav/topnav.component';
import { FooterComponent } from '@app/components/footer/footer.component';
import { ActionLinkComponent } from '@app/components/actions/action-link/action-link.component';
import { ActionRouterLinkComponent } from '@app/components/actions/action-router-link/action-router-link.component';
import { ActionButtonComponent } from '@app/components//actions/action-button/action-button.component';
import { ToolbarButtonComponent } from '@app/components/header/toolbar-button/toolbar-button.component';
import { UserMenuComponent } from '@app/components/header/user-menu/user-menu.component';
import { LogoComponent } from '@app/components/header/logo/logo.component';
import { ProjectListComponent } from './components/project-list/project-list.component';
import { ManagedProjectsComponent } from './views/managed-projects/managed-projects.component';
import { CustomerApiTestComponent } from './views/customer-api-test/customer-api-test.component';
import { CustomerApiTestingComponent } from './components/customer-api-testing/customer-api-testing.component';
import { CloseProjectFormComponent } from './components/close-project-form/close-project-form.component';
import { ArchiveProjectFormComponent } from './components/archive-project-form/archive-project-form.component';
import { ArchiveProjectComponent } from './views/archive-project/archive-project.component';
import { CloseProjectComponent } from './views/close-project/close-project.component';
import { EditProjectRetentionComponent } from './views/edit-project-retention/edit-project-retention.component';
import { EditProjectInfoclassComponent } from './views/edit-project-infoclass/edit-project-infoclass.component';
import { EditProjectInfoclassFormComponent } from './components/edit-project-infoclass-form/edit-project-infoclass-form.component';
import { EditProjectRetentionFormComponent } from './components/edit-project-retention-form/edit-project-retention-form.component';
import { WINDOW } from './common/app-tokens';
import { AppInitService } from './services/app-init.service';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    TopnavComponent,
    ActionLinkComponent,
    ActionRouterLinkComponent,
    ActionButtonComponent,
    ToolbarButtonComponent,
    FilterPipe,
    AllProjectsComponent,
    MyProjectsComponent,
    UserMenuComponent,
    LogoComponent,
    MainComponent,
    ProjectListComponent,
    ManagedProjectsComponent,
    CustomerApiTestComponent,
    CustomerApiTestingComponent,
    CloseProjectFormComponent,
    ArchiveProjectFormComponent,
    ArchiveProjectComponent,
    CloseProjectComponent,
    EditProjectRetentionComponent,
    EditProjectInfoclassComponent,
    EditProjectInfoclassFormComponent,
    EditProjectRetentionFormComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    SharedModule,
  ],
  entryComponents: [
  ],
  exports: [
    AppComponent,
    FooterComponent,
    TopnavComponent,
    ActionLinkComponent,
    ActionRouterLinkComponent,
    ActionButtonComponent,
    ToolbarButtonComponent,
    FilterPipe,
    UserMenuComponent,
    LogoComponent,
  ]
})
export class WorkplaceAppModule {
  constructor(@Optional() @SkipSelf() parentModule: WorkplaceAppModule) {
    if (parentModule) {
      throw new Error(
        'WorkplaceAppModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders<WorkplaceAppModule> {
    return {
      ngModule: WorkplaceAppModule,
      providers: [
        [{
          provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true,
        },
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [AppInitService],
          useFactory: initAndAuthenticate
        }
      ]
      ]
    };
  }

}

export function initAndAuthenticate(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.init();
  };
}
